import { TextArea } from "@certn/cascadia-react";
import { slugifyPath } from "@certn/utils";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { SummaryItem } from "../components/SummaryItem";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function TextAreaControl(props: CascadiaControlProps) {
  const { isSummaryForPath, formID } = useContext(CascadiaJsonFormContext);

  if (
    isSummaryForPath?.(props.path) &&
    // some fields are displayed as readonly text boxes rather than summary items
    !props.options?.renderSummaryAsReadOnly
  ) {
    return (
      <SummaryItem
        label={props.label}
        labelAlign={props.uischema.options?.labelAlign}
      >
        {props.data}
      </SummaryItem>
    );
  }

  const inputName = slugifyPath(props.path);

  return (
    <TextArea
      description={props.description}
      errors={props.errors}
      isBlurred={props.touched}
      isDisabled={!props.enabled || isSummaryForPath?.(props.path)}
      isInvalid={props.invalid}
      isRequired={props.required}
      label={props.label}
      maxLength={props.schema.maxLength}
      minLength={props.schema.minLength}
      name={props.path}
      onBlur={props.setTouched}
      onChange={props.setValue}
      pattern={props.schema.pattern}
      placeholder={props.uischema.options?.placeholder}
      type={props.schema.format}
      value={props.data}
      testID={formID ? `${formID}-${inputName}-input` : `${inputName}-input`}
      labelAlign={props.uischema.options?.labelAlign}
    />
  );
}

TextAreaControl.displayName = "TextAreaControl";

export const TextAreaControlRenderer =
  withCascadiaControlProps(TextAreaControl);
